const MinimumPrice = ({ minimumPrice }: { minimumPrice: string }) =>
  !minimumPrice ? null : <span>{`Fra ${minimumPrice},- inkl. garn`}</span>;

export default MinimumPrice;
